module.exports = "/img/story-2-m.35e0283c.png";